jQuery(document).ready(function($) {

  if ( $('.o-featured-podcasts')[0] ) {
    $('.o-featured-podcasts__list').slick({
      asNavFor: '.o-featured-podcasts__text-list',
      arrows: false
    });

    $('.o-featured-podcasts__text-list').slick({
      asNavFor: '.o-featured-podcasts__list',
      arrows: false
    }).on('afterChange', function(slick, currentSlide, nextSlide) {
      $(this).closest('.o-featured-podcasts').find('.o-featured-podcasts__current').text(nextSlide+1);
      $('.o-featured-podcasts .m-podcast-cta').trigger('unexpand');
    });

    $('.o-featured-podcasts__arrow--prev').click(function() {
      const $parent  = $(this).closest('.o-featured-podcasts');
      const $images  = $parent.find(".o-featured-podcasts__list");

      $images.slick('slickPrev');
    });

    $('.o-featured-podcasts__arrow--next').click(function() {
      const $parent  = $(this).closest('.o-featured-podcasts');
      const $images  = $parent.find(".o-featured-podcasts__list");

      $images.slick('slickNext');
    });
  }

});